module.exports = __webpack_public_path__ + "assets/img/38_352.81977e6e.jpg";